import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Sociedade {
  cpf?: string;
  cnpj?: string;
  razao_social?: string;
  participacao?: string;
  situacao?: string;
  numero?: string;
}

export interface LeadDadosComplementar {
  id: string;
  cnpj: string;
  razao_social?: string;
  fantasia?: string;
  consultor_nome?: string;
  linhas?: number;
  meses_contrato?: number;
  classificacao?: string;
  territorio?: string;
  aptidao?: string;
  
  // Contatos
  telefone_sistema?: string;
  fixo1?: string; operadora_fixo1?: string;
  fixo2?: string; operadora_fixo2?: string;
  fixo3?: string; operadora_fixo3?: string;
  fixo4?: string; operadora_fixo4?: string;
  celular1?: string; operadora_celular1?: string; whatsapp1?: boolean;
  celular2?: string; operadora_celular2?: string; whatsapp2?: boolean;
  celular3?: string; operadora_celular3?: string; whatsapp3?: boolean;
  celular4?: string; operadora_celular4?: string; whatsapp4?: boolean;
  
  // Endereço
  endereco?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  uf?: string;
  cep?: string;
  
  // Dados empresa
  restricao_bancaria?: boolean;
  data_abertura?: string;
  email1?: string;
  email2?: string;
  email3?: string;
  capital_social?: number;
  cod_cnae?: string;
  descricao_cnae?: string;
  qtd_funcionario?: number;
  tipo_filial?: string;
  natureza_empresa?: string;
  descricao_natureza?: string;
  porte_empresa?: string;
  nome_adm?: string;
  
  // Novos campos Planilha 2
  situacao_cadastral?: string;
  data_emissao?: string;
  tipo_empresa?: string;
  faturamento_presumido?: number;
  setor_publico?: string;
  empresa_individual?: string;
  porte_funcionarios?: string;
  data_situacao?: string;
  motivo_situacao_cadastral?: string;
  situacao_especial?: string;
  data_situacao_especial?: string;
  qtde_socios?: number;
  data_enriquecimento?: string;
  
  // Sócio 1
  cpf_socio1?: string; nome_socio1?: string; cargo_socio1?: string;
  endereco_socio1?: string; numero_socio1?: string; complemento_socio1?: string;
  bairro_socio1?: string; cidade_socio1?: string; uf_socio1?: string; cep_socio1?: string;
  telefone1_socio1?: string; telefone2_socio1?: string; telefone3_socio1?: string;
  participacao_socio1?: string; situacao_socio1?: string; cnpj_socio1?: string;
  
  // Sócio 2
  cpf_socio2?: string; nome_socio2?: string; cargo_socio2?: string;
  endereco_socio2?: string; numero_socio2?: string; complemento_socio2?: string;
  bairro_socio2?: string; cidade_socio2?: string; uf_socio2?: string; cep_socio2?: string;
  telefone1_socio2?: string; telefone2_socio2?: string; telefone3_socio2?: string;
  participacao_socio2?: string; situacao_socio2?: string; cnpj_socio2?: string;
  
  // Sócio 3
  cpf_socio3?: string; nome_socio3?: string; cargo_socio3?: string;
  endereco_socio3?: string; numero_socio3?: string; complemento_socio3?: string;
  bairro_socio3?: string; cidade_socio3?: string; uf_socio3?: string; cep_socio3?: string;
  telefone1_socio3?: string; telefone2_socio3?: string; telefone3_socio3?: string;
  participacao_socio3?: string; situacao_socio3?: string; cnpj_socio3?: string;
  
  // Sócio 4
  nome_socio4?: string; cargo_socio4?: string;
  telefone1_socio4?: string; whatsapp_socio4?: boolean;
  
  // WhatsApp dos Sócios 1-3
  whatsapp_socio1?: boolean;
  whatsapp_socio2?: boolean;
  whatsapp_socio3?: boolean;
  
  // Sociedades JSONB
  sociedades?: Sociedade[];
  
  created_at?: string;
  updated_at?: string;
}

export function useLeadDadosComplementar(cnpj: string | undefined) {
  return useQuery({
    queryKey: ['lead-dados-complementar', cnpj],
    queryFn: async () => {
      if (!cnpj) return null;
      
      const cnpjNormalizado = cnpj.replace(/\D/g, '');
      
      const { data, error } = await supabase
        .from('leads_dados_complementar')
        .select('*')
        .eq('cnpj', cnpjNormalizado)
        .maybeSingle();
      
      if (error) {
        console.error('Erro ao buscar dados complementar:', error);
        throw error;
      }
      
      return data as LeadDadosComplementar | null;
    },
    enabled: !!cnpj && cnpj.replace(/\D/g, '').length >= 11,
    staleTime: 5 * 60 * 1000,
  });
}
